module.exports = "<div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"changerListView.set(6)\">\n    <span class=\"glyphicon glyphicon-th-large\" aria-hidden=\"true\"></span>\n  </button>\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"changerListView.set(12)\">\n    <span class=\"glyphicon glyphicon-th-list\" aria-hidden=\"true\"></span>\n  </button>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/active/changer-list-view/changer-list-view.html
 ** module id = 189
 ** module chunks = 0
 **/